import { AnimatePresence } from 'framer-motion';
import { VscLightbulbSparkle } from 'react-icons/vsc';
import { useBookingContext } from '../../../contexts/BookingProvider';
import { AvailableAssociateRes } from '../../../types/appointments';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import BookingSuggestionModal from '../../CommonComps/Modals/BookingSuggestionModal';

const BookingSuggestionAction = () => {
  // integration of context hooks here
  const { gridViewData, showSuggestionModal, setShowSuggestionModal } =
    useBookingContext();

  // rendering booking suggestion action component here
  return (
    <div>
      <AcademiaButton
        onClick={() => setShowSuggestionModal(true)}
        type='button'
        variant='info'
        icon={<VscLightbulbSparkle className='size-6' />}
        additionalClassNames='!py-2'
      >
        Grid View
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showSuggestionModal ? (
          <BookingSuggestionModal
            handleModalClose={() => setShowSuggestionModal(false)}
            gridViewData={gridViewData as AvailableAssociateRes}
          />
        ) : null}
      </AnimatePresence>
    </div>
  );
};

export default BookingSuggestionAction;
